'use client';
import { LogOut } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shared/ui/dropdown';
import { Button } from '@shared/ui/button';
import { UsernameDisplay } from '@entities/user';
import { UserCredentials, useAuth } from '@entities/auth';

type UserNavProps = {
  user: UserCredentials;
};

export const UserNav = ({ user }: UserNavProps) => {
  const { logout } = useAuth();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <UsernameDisplay
          user={{
            name: user.name || null,
            image: undefined || null,
            email: user.email,
          }}
          className="h-10 w-10 cursor-pointer"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <div className="flex items-center justify-start gap-4 p-2 focus:outline-none">
          <div className="flex flex-col space-y-1 leading-none">
            {user.name && <p className="font-sans">{user.name}</p>}
            {user.email && (
              <p className="w-[200px] truncate text-sm text-muted-foreground/60">
                {user.email}
              </p>
            )}
          </div>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => {
              void logout();
            }}
          >
            <LogOut className="mr-2 h-4 w-4" aria-hidden="true" />
            Log Out
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
